export enum EventLabel {
  SWITCH_ACCOUNT_RELOAD = "switch-account:reload",
  SWITCH_COMPANY = "switch-company:switch",
  SWITCH_ACCOUNT_RELOAD_HOME = "switch-account:reload-home",
  LOAD_MENU = "load:menu",
  USER_PAGEBUILDER_GD = "user:pagebuilderGD",
  USER_CREATED = "user:created",
  OPEN_PAGE = "user:openPage",
  ATTENDANCE_RECORD_ATTENDANCE = "ATTENDANCE:RECORDATTENDANCE",
  ATTENDANCE_CHECK_OFFLINE_DATA = "attendance:checkofflinedata",
  ATTENDANCE_SUCCESS_RECORD = "attendance:success-record-attendance",
  COMPANY_SWITCH_DONE = "company:switchdone",
  COMPANY_SWITCH = "company:switch",
  MULTIACCOUNT_SWITCH_DONE = "multiaccount:switchdone",
  USER_LOGOUT = "user:logout",
  USER_SETTING = "user:setting",
  USER_APP_VERSION = "user:appversion",
  USER_GET_PAGEBUILDER = "user:getpagebuilder",
  USER_GET_STATIC_BUILDER = "user:getstaticbuilder",
  USER_GET_CUSTOM = "user:getcustom",
  OPEN_MAPS_GREATDAY_PAGE = "maps:opengreatdaymaps",
  RESPONSE_MAPS_GREATDAY_PAGE = "maps:responsemaps",
}


// WEBPACK FOOTER //
// ./src/helpers/event-label.ts